/* eslint-disable */
import { HintsType } from '../ContactSearchPanelEnum';
export default {
  [HintsType.thirdPartyNoRecordsContent]:
    'Ingrese al menos {minimumLength} caracteres o dígitos para buscar todos los registros de {sourceName}.',
  [HintsType.noFilterOrSearchRecordsTitle]: 'No hay resultados',
  [HintsType.noFilterOrSearchRecordsContent]:
    'Verifique los resultados desde otras fuentes o cambie la palabra clave.',
  [HintsType.searching]: 'Buscando…',
  companyTabTitle: 'Empresa',
  personalTabTitle: 'Personal',
  direct: 'Directo',
  extension: 'Ext.',
  contact: 'Contacto',
  mobile: 'Móvil',
  company: 'Empresa',
  home: 'Inicio',
  home2: 'Inicio',
  other: 'Otro',
  business: 'Trabajo',
  business2: 'Trabajo',
  car: 'Coche',
  fax: 'Fax',
  assistant: 'Asistente',
  callback: 'Devolver llamada',
  MobileNumber: 'Número de móvil',
  ContactNumber: 'Número de contacto',
  DirectNumber: 'Número directo',
  doNotCall: 'No llamar',
} as const;

// @key: @#@"[HintsType.thirdPartyNoRecordsContent]"@#@ @source: @#@"Enter at least {minimumLength} characters or digits to search all {sourceName} records."@#@
// @key: @#@"[HintsType.noFilterOrSearchRecordsTitle]"@#@ @source: @#@"No results found"@#@
// @key: @#@"[HintsType.noFilterOrSearchRecordsContent]"@#@ @source: @#@"Check results from other sources or change your keyword."@#@
// @key: @#@"[HintsType.searching]"@#@ @source: @#@"Searching..."@#@
// @key: @#@"companyTabTitle"@#@ @source: @#@"Company"@#@
// @key: @#@"personalTabTitle"@#@ @source: @#@"Personal"@#@
// @key: @#@"direct"@#@ @source: @#@"Direct"@#@
// @key: @#@"extension"@#@ @source: @#@"Ext"@#@
// @key: @#@"contact"@#@ @source: @#@"Contact"@#@
// @key: @#@"mobile"@#@ @source: @#@"Mobile"@#@
// @key: @#@"company"@#@ @source: @#@"Company"@#@
// @key: @#@"home"@#@ @source: @#@"Home"@#@
// @key: @#@"home2"@#@ @source: @#@"Home"@#@
// @key: @#@"other"@#@ @source: @#@"Other"@#@
// @key: @#@"business"@#@ @source: @#@"Business"@#@
// @key: @#@"business2"@#@ @source: @#@"Business"@#@
// @key: @#@"car"@#@ @source: @#@"Car"@#@
// @key: @#@"fax"@#@ @source: @#@"Fax"@#@
// @key: @#@"assistant"@#@ @source: @#@"Assistant"@#@
// @key: @#@"callback"@#@ @source: @#@"Callback"@#@
// @key: @#@"MobileNumber"@#@ @source: @#@"Mobile Number"@#@
// @key: @#@"ContactNumber"@#@ @source: @#@"Contact Number"@#@
// @key: @#@"DirectNumber"@#@ @source: @#@"Direct Number"@#@
// @key: @#@"doNotCall"@#@ @source: @#@"Do Not Call"@#@
